import { postRequest, getRequest } from "../../helpers/request";

export const TYPES = {
  API_REQUEST: "API_REQUEST",
  API_ERROR: "API_ERROR",
  API_SUCCESS: "API_SUCCESS",

  GET_EMAILER_LIST_SUCCESS: "GET_EMAILER_LIST_SUCCESS",
  CREATE_EMAILER_SUCCESS: "CREATE_EMAILER_SUCCESS",
};

export const createEmailer = (formData) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const response = await postRequest(`emailer`, formData);

    if (response.data.isSuccess) {
      alert("RTE is created");
      dispatch({
        type: TYPES.CREATE_EMAILER_SUCCESS,
        data: response.data.emailer,
      });
    } else {
      if (response.data.msg) {
        alert(response.data.msg);
      }
      dispatch({ type: TYPES.API_ERROR, data: response.data.msg });
    }
  } catch (error) {
    alert(error);
    dispatch({ type: TYPES.API_ERROR, data: error });
  }
};

export const listEmailers = () => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await getRequest(`emailer`);
    if (data.isSuccess) {
      dispatch({
        type: TYPES.GET_EMAILER_LIST_SUCCESS,
        data: data.emailers,
      });
    } else {
      if (data.msg) {
        alert(data.msg);
      }
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    alert(error);
    dispatch({ type: TYPES.API_ERROR, error: error });
  }
};
